import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

export const ContentTypeShow = () => (
  <Show title="Content type details">
    <SimpleShowLayout>
      <TextField source="name" label="Name" />
      <TextField source="display_name" label="Display Name" />
      <TextField source="description" label="Description" />
    </SimpleShowLayout>
  </Show>
);

